import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface PoDocumentPreviewDialogData {
  url: string;
  name: string;
  mimeType: string;
}

@Component({
  selector: 'app-po-document-preview-dialog',
  templateUrl: './po-document-preview-dialog.component.html',
  styleUrls: ['./po-document-preview-dialog.component.scss'],
})
export class PoDocumentPreviewDialogComponent implements OnDestroy {
  readonly safeUrl: SafeResourceUrl;
  readonly isImage: boolean;

  constructor(
    private readonly dialogRef: MatDialogRef<PoDocumentPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: PoDocumentPreviewDialogData,
    sanitizer: DomSanitizer,
  ) {
    this.safeUrl = sanitizer.bypassSecurityTrustResourceUrl(data.url);
    this.isImage = data.mimeType.startsWith('image/');
  }

  ngOnDestroy(): void {
    URL.revokeObjectURL(this.data.url);
  }

  close(): void {
    this.dialogRef.close();
  }
}
